import { ObstacleVersion, ObstacleCollisionArea, ObstacleShadow } from "../ObstacleVersion";
import { eModelAsset, eAtlas_0 } from "../../../../Game";
import { GameWorld } from "../../GameWorld";



export class RotatorObsVer extends ObstacleVersion {
    /**
     * (RO) Rychlost rotace. Kolik vterin trva otoceni o 90 stupnu
     */
    get rotationSpeed(): number { return this._rotSpeed; }
    private _rotSpeed: number;

    /**
     * (RO) Delka zatavky po otoceni o 90 stupnu
     */
    get stopLen(): number { return this._stopLen; }
    private _stopLen: number;

    /**
     * (RO) Ease funkce pro rotaci
     */
    get rotationEase(): (k: number) => number { return this._rotEase; }
    private _rotEase: (k: number) => number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(rotSpeed: number, rotEase: (k: number) => number, stopLen: number) {
        super(0,
            eModelAsset.pillar_1,
            0,
            [
                // Sloupek
                new ObstacleCollisionArea(new pc.BoundingBox(new pc.Vec3(0, 0.3, 0), new pc.Vec3(0.15, 0.3, 0.15))),
                // Hlava kladiva
                new ObstacleCollisionArea(new pc.BoundingSphere(new pc.Vec3(1, 0, 0), 0.4))
            ],
            new pc.Vec3(1.4, 1, 1.4),
            new ObstacleShadow(eAtlas_0.shadowSquare, 0.6, 0.6, 0, GameWorld.SHADOW_Y, 0, true),
            undefined, 1.5);

        this._rotSpeed = rotSpeed;
        this._rotEase = rotEase;
        this._stopLen = stopLen;
    }
}